import * as React from 'react';
import Link from 'next/link';
import styled from 'styled-components';

import { themeGet, media } from '@packages/ui';

import { SimpleSlider } from '../../contentful/SimpleSlider/SimpleSlider';

const Title = styled.div`
  padding-top: 16px;
  text-align: center;
  font-size: 16px;
  border-bottom: 2px solid transparent;
  transition: transform 0.2s ease-out 0s;
  white-space: pre-line;
`;

const Wrapper = styled.div`
  a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-decoration: none;
  }
  img {
    transition: transform 0.2s ease-out 0s;
  }
  &:hover {
    img {
      transform: scale(1.11, 1.11);
    }
    ${Title} {
      color: ${themeGet.colors('primary')};
      border-bottom: 2px solid ${themeGet.colors('primary')};
    }
  }
  ${media.from.sm`
    max-width: 130px;
  `}
`;

const SLIDE_INITIAL_SIZE_PX = 114;

const ImageContainer = styled.div`
  width: 80px;
  ${media.from.lg`
    width: ${SLIDE_INITIAL_SIZE_PX}px;
  `}
`;

interface DYImageSliderItemProps {
  onClick: VoidFunction;
  item: SliderItemSimple | SliderItemAdvanced;
}

function getItemUrl(item: SliderItemSimple | SliderItemAdvanced) {
  if ('imageUrl' in item) {
    return item.imageUrl || '';
  }
  return item.image?.url || '';
}

function getItemText(item: SliderItemSimple | SliderItemAdvanced) {
  if ('text' in item) {
    return item.text || '';
  }
  return item.title || '';
}

const DYImageSliderItem = ({ item, onClick }: DYImageSliderItemProps) => {
  const { link } = item;
  return (
    <Wrapper onClick={onClick}>
      <Link href={link}>
        <a>
          <ImageContainer>
            <img
              src={getItemUrl(item)}
              alt={getItemText(item)}
              width={SLIDE_INITIAL_SIZE_PX}
              height={SLIDE_INITIAL_SIZE_PX}
            />
          </ImageContainer>
          <Title>{getItemText(item)}</Title>
        </a>
      </Link>
    </Wrapper>
  );
};

interface SliderItemBase {
  link: string;
}

// TODO: There may be still templates using this, maybe deprecate in the future
interface SliderItemSimple extends SliderItemBase {
  imageUrl: string;
  title: string;
}

interface SliderItemAdvanced extends SliderItemBase {
  image: {
    height: string;
    width: string;
    url: string;
  };
  text: string;
}

interface DYImageSliderProps {
  data: {
    items: (SliderItemSimple | SliderItemAdvanced)[];
  };
  onClick: VoidFunction;
}

const Background = styled.div`
  background-color: ${themeGet.colors('white')};
`;

export const DYImageSlider = ({ data, onClick }: DYImageSliderProps): JSX.Element => {
  const { items } = data;
  return (
    <Background>
      <SimpleSlider shownItems={[3, 3, 5, 6, 6, 9]}>
        {items.map((item, idx) => (
          <DYImageSliderItem key={idx} onClick={onClick} item={item} />
        ))}
      </SimpleSlider>
    </Background>
  );
};
